import { API_ENDPOINTS } from "../../constants/apiEndpoints";
import { ENVIRONMENT_CONFIG } from "../../constants/environmentConfig";
import fetcher from "../../helpers/fetcher";

export const getDepartmentPriceBreakdownData = async (filters: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.ANALYSIS.GET_PRICE_BREAKDOWN,
      filters,
      undefined,
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMunicipalityPriceBreakdownData = async (filters: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.ANALYSIS.GET_PRICE_BREAKDOWN,
      filters,
      undefined,
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEstablishmentPriceBreakdownData = async (filters: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.ANALYSIS.GET_PRICE_BREAKDOWN,
      filters,
      undefined,
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
